import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation } from "react-router";

type Location = ReturnType<typeof useLocation>;
const BacknavLocationsContext = createContext<Location[]>([]);

export function useBacknavLocations() {
  return useContext(BacknavLocationsContext);
}

const MAX_LOCATIONS = 10;

export function BacknavLocationsProvider({
  children,
}: PropsWithChildren<unknown>) {
  const location = useLocation();
  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    setLocations((p) => [location, ...p].slice(0, MAX_LOCATIONS));
  }, [location]);

  return (
    <BacknavLocationsContext.Provider value={locations}>
      {children}
    </BacknavLocationsContext.Provider>
  );
}
